export function isParticipantStreamSettings(
  settings: App.Connect.StreamSettings,
): settings is App.Connect.ParticipantStreamSettings {
  return 'audio' in settings;
}
